import _ from 'lodash'
import { AuthState } from '@/modules/auth/store'
import { Location } from 'vue-router'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import { Config } from '@/modules/core/config'
import themes, { PrologueTheme } from '@/themes'
import { VuetifyThemeItem } from 'vuetify/types/services/theme'

export class Version {
    constructor (
        public mayor = 0,
        public minor = 0,
        public patch = 0,
    ) {}

    public toString (): string {
        return `${this.mayor}.${this.minor}.${this.patch}`
    }

    public static fromString (version: string) {
        const [mayor, minor, patch] = version.split('.').map(n => parseInt(n, 10))

        return new this(mayor, minor, patch)
    }
}

export interface GoToAction {
    buttonName: string
    route: Location,
}

export class Notification {
    public readonly timestamp = new Date()
    public readonly id = _.uniqueId('notification_')
    public goToAction?: GoToAction
    public subject = ''

    constructor (public message: string, public color = 'success') {}
}

/**
 * Estado raíz
 */
export interface RootState {
    [x: string]: any;
    version: Version
    notification: NotificationState
    loadingScreen: LoadingScreenState
    toolbar: ToolbarState
    sidenav: SidenavState
    // auth?: AuthState,
    enabledModules: string[],
    enabledModulesFetched: boolean,
    menuItems: MenuItem[]
    dashButtons: DashButton[]
    stopNavigation: boolean
    config: Config
    themes: PrologueTheme[]
    currentTheme: PrologueTheme
    themeSelector: boolean
    inputStyle: InputStyle
    darkMode: boolean
    permanentNavigation: boolean
    displayTemporalNavigation: boolean
    /**
     * Define el modo en el que será mostrado el menú de navegación de la aplicación.
     * Existen dos opciones:
     *  - Permanente: El menú siempre aparece
     *  - Minificado: El menú aparece como una barra vertical con solo los iconos.
     */
    navigationMode: NavigationMode
    /**
     * Controla la visibilidad de la capa superpuesta que muestra la información
     * sobre el tamaño de pantalla y breakpoint actual
     */
    displaySizeOverlay: boolean
}

export enum NavigationMode {
    Permanent = 'permanent',
    OpenOnHover = 'open-on-hover',
}

export enum InputStyle {
    Classic = 'classic',
    Solo = 'solo',
    Box = 'box',
    Outline = 'outline',
}

/**
 * Elemento del menu de navegación
 */
export interface MenuItem {
    title: string
    icon: string
    routeName?: string
    children?: MenuItem[]
    module?: string
    permission?: string
    requireAuthorization: boolean
    /**
     * Parámetros por defecto que el menu registrará en la ruta
     */
    params?: KeyValuePair
}

export interface DashButton {
    name: string
    icon: string
    colorClass: string
    link: {name: string, params?: KeyValuePair}
    module: string
}

/**
 * Estado del componente de notificaciones de la aplicación
 */
export interface NotificationState {
    visible: boolean
    message: string
    color: string,
    center: {
        visible: boolean,
        stack: Notification[],
        unread: number,
    },
}

/**
 * Estado de la pantalla de carga
 */
export interface LoadingScreenState {
    visible: boolean
    message: string
    fullscreen: boolean
    brand: boolean
    determinate: boolean
    progress: number
    progressMessage: string
}

/**
 * Estado de la barra de herramientas
 */
export interface ToolbarState {
    visible: boolean
    title: string
}

export interface SidenavState {
    visible: boolean
}
